import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */

import { jsx, Container } from 'theme-ui';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export const MainContainer = _ref => {
  let {
    children
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return jsx(Container, _extends({
    sx: styles.container
  }, rest), children);
};

if (typeof MainContainer !== 'undefined' && MainContainer && MainContainer === Object(MainContainer) && Object.isExtensible(MainContainer) && !MainContainer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(MainContainer, '__filemeta', {
    configurable: true,
    value: {
      name: "MainContainer",
      filename: "../../node_modules/gatsby-theme-docz/src/components/MainContainer/index.js"
    }
  });
}